import Navigation from "../components/utils/Navigation";
import SARepoView from '../components/dialogs/view/SARepoView';
import NoDataAvailable from '../components/utils/NoDataAvailable';
import { getMapWithCategoriesAndPlatformTypes, waitSeconds } from "../utils/utilitiesmodule";
import { deleteRepository, duplicateRepository } from "../utils/entityMethods/repository";

export default {
    name: "Repositories",
    data() {
        return {
            repositories: null,
            serviceAccount: null,
            repository: null,
            selectedIndex: -1,

            cloudTypes: [],
            microsoftTypes: [],

            repositoriesTypes: null,
            filter_type: -1,
            filter_name: '',
        };
    },
    props: {
        msg: String,
    },
    watch: {
        '$route': {
            handler: function(to) {

                if (to.hash=="")
                    return;
                var action, idRepository;
                if (!to.hash.contains(":")) {
                    action="";
                    idRepository=to.hash.replace("#", "");
                } else {
                    [action, idRepository]=to.hash.split(":");
                }
                //to.hash= #[action]:[idRepository]
                var selectedRepo=this.$session.getRepositoryWithID(idRepository);
                switch (action) {
                    case "#delete":
                        this.deleteRepository(selectedRepo);
                        return;

                    case "#details":
                        this.$root.$emit("OPENSAREPOVIEW", this.$session.getServiceAccountWithID(selectedRepo.id_service_account), selectedRepo);
                        return;
                    case "#duplicate":
                        this.duplicateRepository(selectedRepo);
                        return;
                    default:
                        this.$root.$emit('OPENREPOSITORYDIALOG', selectedRepo);
                }

            },
            deep: true,
            immediate: true
        }
    },
    beforeDestroy: async function() {
        this.repositories=null;
        this.$root.$off("REFRESHREPOSITORIES");
        this.$root.$off("socketEventConnected");
        this.$root.$off("socketEventDisconnected");
    },
    created: function() {
        this.repositoriesTypes=getMapWithCategoriesAndPlatformTypes("forRepository", true);

        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        //this.$root.newPage("repositories", "created");
        let self=this;
        this.repositories=self.$session.getRepositories();
        this.$root.$on("REFRESHREPOSITORIES", () => {
            self.repositories.clear();
            waitSeconds(0.1).then(() => {
                self.repositories.update(self.$session.getRepositories());
            })
        });

        this.cloudTypes=this.$root.getCloudTypes();
        this.microsoftTypes=this.$root.getMicrosoftTypes();

    },

    components: {
        NoDataAvailable,
        Navigation,
        SARepoView
    },
    methods: {
        duplicateRepository,
        deleteRepository,
        see(repo) {
            //apre un charm nella pagina
            this.serviceAccount=this.$session.getServiceAccountWithID(repo.id_service_account);
            this.repository=repo;
            window.Metro.charms.toggle("#reposelected");
        },


        closeCharm() {
            window.Metro.charms.toggle("#reposelected");
        }
    }
}